function key(agentId: string, visitorId: string, conversationId?: string) {
  return `cg:draft:${agentId}:${visitorId}:${conversationId ?? 'new'}`;
}

export function loadDraft(
  agentId: string,
  visitorId: string,
  conversationId?: string
): string {
  try {
    return localStorage.getItem(key(agentId, visitorId, conversationId)) ?? '';
  } catch {
    return '';
  }
}

export function saveDraft(
  agentId: string,
  visitorId: string,
  conversationId: string | undefined,
  value: string
): void {
  try {
    if (!value) {
      localStorage.removeItem(key(agentId, visitorId, conversationId));
    } else {
      localStorage.setItem(key(agentId, visitorId, conversationId), value);
    }
  } catch {
    /* ignore quota / privacy */
  }
}

export function clearDraft(
  agentId: string,
  visitorId: string,
  conversationId?: string
): void {
  try {
    localStorage.removeItem(key(agentId, visitorId, conversationId));
  } catch {}
}
